import { Badge, Skeleton } from '@monksflow/monks-ui';
import { Modal } from '@/shared/ui';
import { AgentAvatar } from '../AgentAvatar';
import { useFeatureAgent } from '../../model/use-feature-agent';
import { AgentModalProps } from './AgentModal.types';
import { useTranslation } from 'react-i18next';

export const AgentModal = ({ open, onClose, agentId, workspaceId }: AgentModalProps) => {
  const { t } = useTranslation('admin');

  const { agent: featuredAgent, isLoading } = useFeatureAgent(agentId, workspaceId);

  return (
    <Modal open={open} onClose={onClose}>
      {isLoading ? (
        <div className="flex flex-col gap-4 p-2 pl-6">
          <div className="flex flex-row items-center gap-4">
            <Skeleton className="size-16 rounded-full" data-testid="skeleton-loader" />
            <div className="flex flex-col gap-1">
              <Skeleton className="h-8 w-37.5" data-testid="skeleton-loader" />
              <div className="flex flex-row gap-2">
                <Skeleton className="h-5 w-12.5" data-testid="skeleton-loader" />
                <Skeleton className="h-5 w-15" data-testid="skeleton-loader" />
              </div>
            </div>
          </div>
          <div className="flex flex-col pt-2">
            <Skeleton className="h-5 w-4/5" data-testid="skeleton-loader" />
          </div>
        </div>
      ) : (
        <div className="flex flex-col gap-4 p-2 pl-6">
          <div className="flex flex-row items-center gap-4">
            <AgentAvatar
              agentId={agentId}
              agentTitle={featuredAgent?.title}
              avatar={featuredAgent?.avatar}
              tag={featuredAgent?.tag}
              variant="large"
            />
            <div className="flex flex-col gap-1">
              <h2 className="max-w-50 text-heading-md text-foreground">{featuredAgent?.title}</h2>
              {featuredAgent?.tag && (
                <div className="flex flex-row gap-2">
                  <Badge variant="secondary">{featuredAgent.tag}</Badge>
                </div>
              )}
            </div>
          </div>
          <div className="flex flex-col pt-2">
            <p className="text-body-sm text-muted-foreground">
              {featuredAgent?.description ?? t('agent.agentModal.noDescriptionDefined')}
            </p>
          </div>
        </div>
      )}
    </Modal>
  );
};
